<div class="properties-button-container" *ngIf="isIndexedPropertiesListAttType">
    <mat-list class="labeled-buttons-container">
        <app-labeled-action-button [isDisabled]="isDisabled" [action]="getIndexedFoliosAttachments.bind(this)"
            [hint]="'Create new attachment CSV file with the list of unique Folios indexed for selected Zoning Code'"
            [icon]="'save_alt'" [label]="'Indexed folios'"></app-labeled-action-button>

        <app-labeled-action-button [isDisabled]="isDisabled" [action]="generateMissedAbuttingPRsAttachment.bind(this)"
            [hint]="missedAbuttingPropertyRecordsHint" [icon]="'save_alt'"
            [label]="'Missed Abutting Property Records'"></app-labeled-action-button>

        <app-labeled-action-button [isDisabled]="isDisabled"
            [action]="generateMissedAbuttingStreetsAttachment.bind(this)" [hint]="missedAbuttingStreetsHint"
            [icon]="'save_alt'" [label]="'Missed Streets'"></app-labeled-action-button>

        <app-labeled-action-button [isDisabled]="isDisabled" [action]="generateMissedPRsTagsAttachment.bind(this)"
            [hint]="missedPropertyRecordsTagsHint" [icon]="'save_alt'"
            [label]="'Missed Property Records Tags'"></app-labeled-action-button>
    </mat-list>
</div>

<div class="properties-button-container" *ngIf="isZoningCodeVersionStatistics">
    <mat-list class="labeled-buttons-container">

        <app-labeled-action-button [isDisabled]="isDisabled" [action]="getFailedFoliosAttachments.bind(this)"
            [hint]="failedFoliosHint" [icon]="'save_alt'" [label]="'Failed properties'"></app-labeled-action-button>

        <app-labeled-action-button [isDisabled]="isDisabled"
            [action]="getPropertiesWithNotificationsAttachments.bind(this)" [hint]="foliosWithNotificationsHint"
            [icon]="'save_alt'" [label]="'Properties with notifications'"></app-labeled-action-button>

        <app-labeled-action-button [isDisabled]="isDisabled" [action]="generateMissedAbuttingPRsAttachment.bind(this)"
            [hint]="missedAbuttingPropertyRecordsHint" [icon]="'save_alt'"
            [label]="'Missed Abutting Property Records'"></app-labeled-action-button>

        <app-labeled-action-button [isDisabled]="isDisabled"
            [action]="generateMissedAbuttingStreetsAttachment.bind(this)" [hint]="missedAbuttingStreetsHint"
            [icon]="'save_alt'" [label]="'Missed Streets'"></app-labeled-action-button>

        <app-labeled-action-button [isDisabled]="isDisabled" [action]="generateMissedPRsTagsAttachment.bind(this)"
            [hint]="missedPropertyRecordsTagsHint" [icon]="'save_alt'"
            [label]="'Missed Property Records Tags'"></app-labeled-action-button>
    </mat-list>
</div>

<ng-container *ngIf=" isLoaded; else spinner">
    <div class="table-container">
        <mat-table [dataSource]="attachmentLinks" style="width: 100%">
            <ng-container matColumnDef="File name">
                <mat-header-cell *matHeaderCellDef>File Name</mat-header-cell>
                <mat-cell class="no-crop" *matCellDef="let attachmentLink"
                    matTooltip="{{attachmentLink.attachmentTypeStr}}">
                    {{ attachmentLink.FileName }}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Actions">
                <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
                <mat-cell *matCellDef="let attachmentLink">
                    <a href="{{ attachmentLink.URL }}" class="download-button-ref">
                        <button mat-icon-button class="actions-buttons">
                            <mat-icon matTooltip="Download" class="actions-mat-icons">
                                cloud_download
                            </mat-icon>
                        </button>
                    </a>

                    <button mat-icon-button class="actions-buttons">
                        <mat-icon matTooltip="Delete" class="actions-mat-icons"
                            (click)="deleteAttachment(attachmentLink.Id, attachmentLink.FileName)">delete
                        </mat-icon>
                    </button>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: columnsToDisplay"></mat-row>
        </mat-table>
    </div>
</ng-container>

<ng-template #spinner>
    <app-spinner></app-spinner>
</ng-template>